import { legalContent } from "../../data/content";

export function PrivacyPolicy() {
  const policy = legalContent.privacy;
  return (
    <article className="max-w-4xl mx-auto px-6 pt-32 pb-20 text-slate-700" aria-labelledby="privacy-title">
      <h1 id="privacy-title" className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">QuickDrop Go — {policy.title}</h1>
      <p className="text-sm mb-10">{policy.updated}</p>
      {policy.body.map((paragraph) => {
        const separator = paragraph.indexOf(": ");
        return <section key={paragraph.slice(0, separator)} className="mb-7">
          <h2 className="text-xl font-semibold text-slate-900 mb-2">{paragraph.slice(0, separator)}</h2>
          <p className="leading-relaxed">{paragraph.slice(separator + 2)}</p>
        </section>;
      })}
      <p className="leading-relaxed">Contact: <a className="text-[#0033FF] underline" href="mailto:quickdropsupport@gmail.com">quickdropsupport@gmail.com</a></p>
      <p className="mt-4 leading-relaxed">Provider policies: <a className="text-[#0033FF] underline" href="https://policies.google.com/privacy">Google</a> and <a className="text-[#0033FF] underline" href="https://razorpay.com/privacy/">Razorpay</a>.</p>
    </article>
  );
}
